module.exports = __webpack_public_path__ + "img/office4.7e9ec18c.jpg";